import BottomMobileDrawer, {
  DrawerItem,
} from 'src/apps/mobile/components/BottomMobileDrawer/BottomMobileDrawer';
import CourseIcon from 'shared/img/course.svg';
import ExtracurricularIcon from 'shared/img/activity.svg';
import CommunityServiceIcon from 'shared/img/community-service.svg';
import WorkExperienceIcon from 'shared/img/work-experience.svg';
import HonorAwardsIcon from 'shared/img/honor-award.svg';
import CollegeReadinessEventIcon from 'shared/img/college-visit.svg';
import ArtMediaIcon from 'shared/img/art-media.svg';

const bottomDrawerItems: DrawerItem[] = [
  {Icon: CourseIcon, text: 'Course', href: (pathname) => `${pathname}/course/new`},
  {
    Icon: ExtracurricularIcon,
    text: 'Extracurricular',
    href: (pathname) => `${pathname}/activity/new`,
  },
  {
    Icon: CommunityServiceIcon,
    text: 'Community Service',
    href: (pathname) => `${pathname}/community-service/new`,
  },
  {
    Icon: WorkExperienceIcon,
    text: 'Work Experience',
    href: (pathname) => `${pathname}/work-experience/new`,
  },
  {
    Icon: HonorAwardsIcon,
    text: 'Honor & Award',
    href: (pathname) => `${pathname}/honor-award/new`,
  },
  {
    Icon: CollegeReadinessEventIcon,
    text: 'Transfer Success',
    href: (pathname) => `${pathname}/college-success/choose/form`,
  },
  {Icon: ArtMediaIcon, text: 'Art and Media', href: (pathname) => `${pathname}/multimedia/new`},
];

const bottomNavbarConfig = {
  contextMenuIndex: 2,
  ContextMenu: BottomMobileDrawer,
  drawerItems: bottomDrawerItems,
  menuHeader: 'ADD TO PORTFOLIO',
  tabs: [
    {
      name: 'Home',
      iconName: 'home',
      key: 'home',
    },
    {
      name: 'My List',
      iconName: 'university',
      key: 'colleges/my-list',
    },
    {},
    {
      name: 'Colleges',
      iconName: 'search',
      key: 'colleges/search',
    },
    {
      name: 'More',
      iconName: 'bars',
      key: 'more',
      activePaths: ['/account-settings', '/messages'],
      showAlert: true,
    },
  ],
};

export default bottomNavbarConfig;
